<template>
  <v-container fluid>
    <!-- file import and list -->
    <el-overlay-loading :loading="pageloading" />
    <template>
      <!-- form  -->
      <v-card outlined class="mb-4">
        <form @keydown.enter.prevent="submit()">
          <v-card-text>
            <v-row class="mb-0 pb-0">
              <v-col class="pb-0" cols="12" md="12">
                <el-file-input
                  label="Dokumentas"
                  v-model="file"
                  @addFile="addFile($event, 'file')"
                ></el-file-input>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <el-button
                class="mr-1"
                color="secondary"
                icon="atšaukti"
                title="Atšaukti"
                @click.native.stop="close()"
                :loading="loading"
              />
              <el-button
                class="mr-1"
                color="primary"
                title="Įkelti"
                @click.native.stop="upload()"
                :loading="loading"
              />
            </v-row>
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import math from '@/mixins/math'

export default {
  name: 'Import',
  mixins: [math],
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    url: {String}
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
      file: null,
      filename: null
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    addFile(file, name) {
      this.file = file
      this.filename = name
    },
    upload() {
      this.loading = true
      this.pageloading = true
      let formData = new FormData()
      formData.append(`file`, this.file)
      this.$axios
        .post(this.url, formData)
        .then((res) => {
          this.$root.$emit('DATA_OK', res.data.message)
          this.file = null
          this.filename = null
          this.$emit('imported')
        })
        .catch((err) => {
          this.file = null
          this.filename = null
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
